import * as Yup from "yup";

//the key inside of each validation must match the name inside of the json.
//if json question has "name":"lastName"
////then Yup validation will have name: Yup.string(validationMessages["string"]).required(validationMessages["required"]),

//put each page's yup object/ validation in a separate element
//make sure each validation params include a custom message that is from the json object below

export function getValidation(questionnaireUUID, vm) {
    //vm = validationMessages
    switch (questionnaireUUID) {
        //testingElements
        case "testingElements":
            return [TestingElementsSchema(vm), TestingElementsFailureSchema(vm)];
        //Proms
        case "120ph":
            return [PromsInitialSchema(vm), EQ5DSchema(vm), StartMskSchema(vm), PSEQ8And9Schema(vm)];
        //Proms south
        case "093pa":
            return [PromsInitialSchema(vm), EQ5DSchema(vm), StartMskSchema(vm)];
        //MskPromsBaseline
        case "12aia":
            return [
                MskSchema(vm),
                EQ5DSchema(vm),
                PSFSSchema(vm),
                StartMskSchema(vm),
                MskBaselineHealthSchema(vm),
                MskBaselinePersonalSchema(vm),
            ];
        //MskPromsDischarge
        case "poa2h":
            return [
                MskSchema(vm),
                EQ5DSchema(vm),
                PSFSSchema(vm),
                StartMskSchema(vm),
                MskDischargeHealthSchema(vm),
                MskDischargePersonalSchema(vm),
                MskPremsSchema(vm),
            ];
        //MskPromsMonthsAfterDischarge
        case "bhaswe":
            return [
                MskSchema(vm),
                EQ5DSchema(vm),
                StartMskSchema(vm),
                MskDischargeHealthSchema(vm),
                MskDischargePersonalSchema(vm),
                MskMonthsDischargePremsSchema(vm),
            ];
        //Decon
        case "92opa":
            return [DeconSchema(vm)];
        //EQ5D
        case "apwed":
            return [EQ5DSchema(vm)];
        //GAD7
        case "bijwa":
            return [GAD7Schema(vm)];
        //MedialBranchBlock
        case "ph28a":
            return [MedialBranchBlockSchema(vm)];
        //MSK
        case "9032m":
            return [MskSchema(vm)];
        //MskBaselineHealth
        case "ejaqr":
            return [MskBaselineHealthSchema(vm)];
        //MskBaselinePersonal
        case "fioja":
            return [MskBaselinePersonalSchema(vm)];
        //MskDischargeHealth
        case "gikow":
            return [MskDischargeHealthSchema(vm)];
        //MskDischargePersonal
        case "hpoaw":
            return [MskDischargePersonalSchema(vm)];
        //MskMonthsDischargePrems
        case "iu890":
            return [MskMonthsDischargePremsSchema(vm)];
        //Msk Prems
        case "kaimj":
            return [MskPremsSchema(vm)];
        //PatientActivation
        case "r03jg":
            return [PAMSchema(vm)];
        //PHQ9
        case "lca91":
            return [PHQ9Schema(vm)];
        //PHQ8
        case "l4289":
            return [PHQ8Schema(vm)];
        //GeneralPromsInitial
        case "mklaw":
            return [PromsInitialSchema(vm)];
        //ManchesterPromsInitial
        case "94lrp":
            return [ManchesterPromsInitialSchema(vm)];
        //PSEQ8And9
        case "n890a":
            return [PSEQ8And9Schema(vm)];
        //PSFS
        case "omaw4":
            return [PSFSSchema(vm)];
        //PSFS Discharge
        case "om6w4":
            return [PSFSDischargeSchema(vm)];
        //SleepProgramme
        case "p21af":
            return [SleepProgrammeSchema(vm)];
        //StartMsk
        case "q456a":
            return [StartMskSchema(vm)];
        //StartBack
        case "q5aaa":
            return [StartBackSchema(vm)];
        //Pain personal
        case "pzk24":
            return [PainPersonalSchema(vm)];
        //Pain personal manchester
        case "kzk2om":
            return [PainPersonalManchesterSchema(vm)];
        //Bpi
        case "pzz23":
            return [BpiSchema(vm)];
        //MPFI
        case "okqnv":
            return [MpfiSchema(vm)];
        //Pain baseline Health
        case "8zkl5":
            return [PainBaselineHealthSchema(vm)];
        //Core 10
        case "lryb0":
            return [Core10Schema(vm)];
        //Pain Discharge personal
        case "o4129":
            return [PainDischargePersonalSchema(vm)];
        //Pain Discharge Health
        case "gnbc1":
            return [PainDischargeHealthSchema(vm)];
        //FFT
        case "qwert":
            return [FftSchema(vm)];
        //Pain Medication
        case "med0p":
            return [PainMedicationSchema(vm)];
        //Pain Satisfaction
        case "uyi12":
            return [PainSatisfactionSchema(vm)];
        default:
            break;
    }
}

export function getValidationMessages() {
    return {
        required: "This field is required!",
        string: "This field must be a string!",
        array: "This field must be an array!",
        minimumOfOne: "This field has a minimum of 1!",
        date: "This field must be a valid date (--/--/----)",
        number: "This field must be a number!",
        generalError: "An error occurred!",
    };
}

function TestingElementsFailureSchema(validationMessages) {
    return Yup.object().shape({
        test12: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test13: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test14: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test15: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test16: Yup.date(validationMessages["date"]).required(validationMessages["required"]),
        test17: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test18: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test19: Yup.array(validationMessages["array"])
            .min(1, validationMessages["required"])
            .of(Yup.string(validationMessages["string"]).trim().required(validationMessages["required"])),
        test20: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test21: Yup.string(validationMessages["string"])
            .min(3, validationMessages["required"])
            .required(validationMessages["required"]),
        test22: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function TestingElementsSchema(validationMessages) {
    return Yup.object().shape({
        test1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test3: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test4: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test5: Yup.date(validationMessages["date"]).required(validationMessages["required"]),
        test6: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test7: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test8: Yup.array(validationMessages["array"])
            .min(1, validationMessages["required"])
            .of(Yup.string(validationMessages["string"]).trim().required(validationMessages["required"])),
        test9: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        test10: Yup.string(validationMessages["string"])
            .min(3, validationMessages["required"])
            .required(validationMessages["required"]),
        test11: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function DeconSchema(validationMessages) {
    return Yup.object().shape({
        describeSymptoms: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        activitiesStopped: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        medication: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        previousTreatment: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function EQ5DSchema(validationMessages) {
    return Yup.object().shape({
        mobility: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        selfCare: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        usualActivities: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        painOrDiscomfort: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        anxietyOrDepression: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        healthToday: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
    });
}

function GAD7Schema(validationMessages) {
    return Yup.object().shape({
        feelingAnxious: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        cantControlWorrying: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        worryingTooMuch: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        troubleRelaxing: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        cantSitStill: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        easilyAnnoyed: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        afraidSomethingAwfulHappens: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function MedialBranchBlockSchema(validationMessages) {
    return Yup.object().shape({
        painRating: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
        painRating30AfterInjection: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
        painRating60AfterInjection: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
        painRating120AfterInjection: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
        painRating180AfterInjection: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
        painRating240AfterInjection: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
        painRating360AfterInjection: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
        painRating480AfterInjection: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
        painRating1DayAfterInjection: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
        comments: Yup.string(validationMessages["string"]),
    });
}

function MskSchema(validationMessages) {
    return Yup.object().shape({
        stiffnessDuringTheDay: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        StiffnessDuringTheNight: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        AbilityToWalk: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        WashingDressing: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PhysicalActivityLevels: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        DailyRoutine: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        SocialActivitiesAndHobbies: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        NeedingHelp: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        TroubleSleeping: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        FatigueOrLowEnergy: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        EmotionalWellBeing: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        CurrentTreatment: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        ManageSymptoms: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        OverallImpact: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PhysicalActivityLevels: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function MskBaselineHealthSchema(validationMessages) {
    return Yup.object().shape({
        painSite: Yup.array(validationMessages["array"])
            .min(1, validationMessages["required"])
            .of(Yup.string(validationMessages["string"]).trim().required(validationMessages["required"])),
        syDuration: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        recommendedAmountOfphysicalActivityLevels: Yup.string(validationMessages["string"]).required(
            validationMessages["required"]
        ),
        healthUtilisation: Yup.string(validationMessages["string"])
            .min(3, validationMessages["required"])
            .required(validationMessages["required"]),
        previousPhysiotherapy: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        investigationsAndTreatments: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function MskBaselinePersonalSchema(validationMessages) {
    return Yup.object().shape({
        dob: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        sexualOrientation: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        ethnicity: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        selfReportedAsDisabled: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        benefitStatus: Yup.array(validationMessages["array"])
            .min(1, validationMessages["required"])
            .of(Yup.string(validationMessages["string"]).trim().required(validationMessages["required"])),
        education: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        workStatus: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function MskDischargeHealthSchema(validationMessages) {
    return Yup.object().shape({
        recommendedAmountOfphysicalActivityLevels: Yup.string(validationMessages["string"]).required(
            validationMessages["required"]
        ),
        healthUtilisation: Yup.string(validationMessages["string"])
            .min(3, validationMessages["required"])
            .required(validationMessages["required"]),
        investigationsAndTreatments: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function MskDischargePersonalSchema(validationMessages) {
    return Yup.object().shape({
        selfReportedAsDisabled: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        benefitStatus: Yup.array(validationMessages["array"])
            .min(1, validationMessages["required"])
            .of(Yup.string(validationMessages["string"]).trim().required(validationMessages["required"])),
        workStatus: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function MskMonthsDischargePremsSchema(validationMessages) {
    return Yup.object().shape({
        fft: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        fftFollowUp: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        globalImprovement: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function MskPremsSchema(validationMessages) {
    return Yup.object().shape({
        fft: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        fftFollowUp: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        collaborate1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        collaborate2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        collaborate3: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        confidenceInClinicalCompetence: Yup.string(validationMessages["string"]).required(
            validationMessages["required"]
        ),
        givenSufficientInformation: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        globalImprovement: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        timeliness: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        convenience: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function PAMSchema(validationMessages) {
    return Yup.object().shape({
        PAM1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PAM2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PAM3: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PAM4: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PAM5: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PAM6: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PAM7: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PAM8: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PAM9: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PAM10: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PAM11: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PAM12: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PAM13: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function PHQ9Schema(validationMessages) {
    return Yup.object().shape({
        botheredByInterests: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        feelingDown: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        troubleSleeping: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        littleEnergy: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        offAppetite: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        feelingBad: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        struggleConcentrating: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        changeInSpeech: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        suicidalThoughts: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function PHQ8Schema(validationMessages) {
    return Yup.object().shape({
        botheredByInterests: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        feelingDown: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        troubleSleeping: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        littleEnergy: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        offAppetite: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        feelingBad: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        struggleConcentrating: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        changeInSpeech: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function PromsInitialSchema(validationMessages) {
    return Yup.object().shape({
        name: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        dob: Yup.date(validationMessages["date"]).required(validationMessages["required"]),
        happyWithService: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        whyAnswer: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        triedMedication: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        problemsWithHealth: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        allergies: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        readingDifficulties: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        hearingOrSpeakingDifficulties: Yup.string(validationMessages["string"]).required(
            validationMessages["required"]
        ),
        expectations: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function ManchesterPromsInitialSchema(validationMessages) {
    return Yup.object().shape({
        name: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        dob: Yup.date(validationMessages["date"]).required(validationMessages["required"]),
        sexualOrientation: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        ethnicGroup: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        happyWithService: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        whyAnswer: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        triedMedication: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        problemsWithHealth: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        allergies: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        readingDifficulties: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        hearingOrSpeakingDifficulties: Yup.string(validationMessages["string"]).required(
            validationMessages["required"]
        ),
        expectations: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function PSEQ8And9Schema(validationMessages) {
    return Yup.object().shape({
        confidentlyAccomplishGoals: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
        confidentlyLiveNormalLifestyle: Yup.number(validationMessages["number"]).required(
            validationMessages["required"]
        ),
    });
}

function PSFSSchema(validationMessages) {
    return Yup.object().shape({
        activity1: Yup.number(validationMessages["number"]),
        activity2: Yup.number(validationMessages["number"]),
        activity3: Yup.number(validationMessages["number"]),
        activity4: Yup.number(validationMessages["number"]),
        activity5: Yup.number(validationMessages["number"]),
    });
}

function PSFSDischargeSchema(validationMessages) {
    return Yup.object().shape({
        activity1: Yup.string(validationMessages["string"]),
        activity2: Yup.string(validationMessages["string"]),
        activity3: Yup.string(validationMessages["string"]),
        activity4: Yup.string(validationMessages["string"]),
        activity5: Yup.string(validationMessages["string"]),
    });
}

function SleepProgrammeSchema(validationMessages) {
    return Yup.object().shape({
        sleepPerNight: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        sleepQuality: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
        sleepPerNightAfter: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        sleepQualityAfter: Yup.number(validationMessages["number"]).required(validationMessages["required"]),
        recommendProgramme: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        whyFeelThisWay: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        benefits: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        useful: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        recommend: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        comments: Yup.string(validationMessages["string"]),
    });
}

function StartMskSchema(validationMessages) {
    return Yup.object().shape({
        painIntensity: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        unsureHowToManagePain: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        onlyAbleToWalkShort: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        botheredALotByPain: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        troublesomeJointPain: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        thinkConditionWillLast: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        otherImportantHealthProblems: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        feelingDepressedCauseOfPain: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        unsafeForPeWithCondition: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        problemFor6MonthsOrMore: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function StartBackSchema(validationMessages) {
    return Yup.object().shape({
        painSpreadDownLegs: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        painShoulderNeck: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        walkShortDistances: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        dressSlowly: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        notSafeToBeActive: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        worryingThoughts: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        backPainTerrible: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        notEnjoyedThings: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        overallBackPain: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function PainPersonalSchema(validationMessages) {
    return Yup.object().shape({
        yearOfBirth: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        painSite: Yup.string().min(3, validationMessages["required"]),
        coMorbidities: Yup.array(validationMessages["array"])
            .min(1, validationMessages["required"])
            .of(Yup.string(validationMessages["string"]).trim().required(validationMessages["required"])),
        symptomDuration: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        highestLevelOfEducation: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        sexAtBirth: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        ethnicity: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        relationshipStatus: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        benefitStatus: Yup.array("")
            .min(1, validationMessages["required"])
            .of(Yup.string(validationMessages["string"]).trim().required(validationMessages["required"])),
        workStatus: Yup.object({
            errors: Yup.array().length(0, validationMessages["required"]),
        }),
    });
}

function PainPersonalManchesterSchema(validationMessages) {
    return Yup.object().shape({
        yearOfBirth: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        painSite: Yup.string().min(3, validationMessages["required"]),
        coMorbidities: Yup.array(validationMessages["array"])
            .min(1, validationMessages["required"])
            .of(Yup.string(validationMessages["string"]).trim().required(validationMessages["required"])),
        symptomDuration: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        highestLevelOfEducation: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        sexAtBirth: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        sexualOrientation: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        ethnicity: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        relationshipStatus: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        benefitStatus: Yup.array("")
            .min(1, validationMessages["required"])
            .of(Yup.string(validationMessages["string"]).trim().required(validationMessages["required"])),
        workStatus: Yup.object({
            errors: Yup.array().length(0, validationMessages["required"]),
        }),
    });
}

function BpiSchema(validationMessages) {
    return Yup.object().shape({
        currentPainIntensity: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        painIntensityPast24Hours: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        usualPainIntensity: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        highestPainIntensity: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        generalActivity: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        mood: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        walkingAbility: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        normalWork: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        relationsWithOtherPeople: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        sleep: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        enjoymentOfLife: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function MpfiSchema(validationMessages) {
    return Yup.object().shape({
        Acceptance1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        Acceptance2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PresentMomentAwareness1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        PresentMomentAwareness2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        SelfAsContext1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        SelfAsContext2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        Defusion1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        Defusion2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        Values1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        Values2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        CommittedAction1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        CommittedAction2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        ExperientialAvoidance1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        ExperientialAvoidance2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        LastOfContact1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        LastOfContact2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        SelfAsContent1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        SelfAsContent2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        Fusion1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        Fusion2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        lackOfContactWithValues1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        lackOfContactWithValues2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        Inaction1: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        Inaction2: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function PainBaselineHealthSchema(validationMessages) {
    return Yup.object().shape({
        timesSeenGp: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        timesSeenDoctor: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        timesSeenEmergency: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        daysAdmittedHospital: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        prescribedMedications: Yup.object({
            errors: Yup.array().length(0, validationMessages["required"]),
        }),
        medicationForPain: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        ableToDoMore: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        expectations: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function Core10Schema(validationMessages) {
    return Yup.object().shape({
        feltTense: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        needSupport: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        ableToCope: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        talkingFeltTooMuch: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        feltPanic: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        difficultyGettingToSleep: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        feltDespairing: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        feltUnhappy: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        distressingImages: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function PainDischargePersonalSchema(validationMessages) {
    return Yup.object().shape({
        benefitStatus: Yup.array("")
            .min(1, validationMessages["required"])
            .of(Yup.string(validationMessages["string"]).trim().required(validationMessages["required"])),
        workStatus: Yup.object({
            errors: Yup.array().length(0, validationMessages["required"]),
        }),
    });
}

function PainDischargeHealthSchema(validationMessages) {
    return Yup.object().shape({
        globalImprovement: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        timesSeenGp: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        timesSeenDoctor: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        timesSeenEmergency: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        daysAdmittedHospital: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        prescribedMedications: Yup.object({
            errors: Yup.array().length(0, validationMessages["required"]),
        }),
        medicationForPain: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        ableToDoMore: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function FftSchema(validationMessages) {
    return Yup.object().shape({
        recommendService: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        effortToUnderstand: Yup.string(validationMessages["string"]),
        effortMadeToListen: Yup.string(validationMessages["string"]),
        effortToInclude: Yup.string(validationMessages["string"]),
    });
}

function PainMedicationSchema(validationMessages) {
    return Yup.object().shape({
        prescribedMedications: Yup.object({
            errors: Yup.array().length(0, validationMessages["required"]),
        }),
        medicationForPain: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        ableToDoMore: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        medicationChanged: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}

function PainSatisfactionSchema(validationMessages) {
    return Yup.object().shape({
        satisfiedWithTreatment: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        satisfiedWithStaff: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        generalComments: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
        sayToSomeone: Yup.string(validationMessages["string"]).required(validationMessages["required"]),
    });
}
